import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators'

import { environment } from '../../environments/environment'
import { SharedDataService } from '../helper/services/shared-data.service'
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkingService {

  constructor(
    private http: HttpClient, 
    private sharedDataService: SharedDataService
  ) { }

  public getRequest<T>(apiEndpoint: string, header?: HttpHeaders, params?: HttpParams) : Observable<T> {
    this.sharedDataService.toggleProgressBarOn()
    return this.http.get<T>(
      `${environment.url}/${environment.backendVersion}/${apiEndpoint}`,
      {
        headers: header ? header : {},
        params: params ? params : {}
      }
    )
  }

  public postRequest(apiEndpoint: string, payload?: any, header?: HttpHeaders) {
    this.sharedDataService.toggleProgressBarOn()
    return this.http.post<any>(
      `${environment.url}/${environment.backendVersion}/${apiEndpoint}`,
      payload,
      {
        headers: header ? header : {}
      }
    ).pipe(map(data =>
      data))
  }

  public fileRequest(apiEndpoint: string, payload?: any) {
    this.sharedDataService.toggleProgressBarOn()
    return this.http.post(
      `${environment.url}/${environment.backendVersion}/${apiEndpoint}`,
      payload,
      {
        responseType: 'blob'
      }
    ).pipe(map(data =>
      data))
  }

  public fileGetRequest(apiEndpoint: string, header: HttpHeaders, params?: HttpParams) {
    this.sharedDataService.toggleProgressBarOn()
    return this.http.get(
      environment.url + apiEndpoint,
      {
        headers: header.set('Cache-Control', 'no-cache'),
        params: params ? params : {},
        responseType: 'blob'
      }
    ).pipe(map(data =>
      data))
  }

  public putRequest(apiEndpoint: string, payload?: any, header?: HttpHeaders) {
    this.sharedDataService.toggleProgressBarOn()
    return this.http.put<any>(
      `${environment.url}/${environment.backendVersion}/${apiEndpoint}`,
      payload,
      {
        headers: header ? header : {}
      }
    ).pipe(map(data =>
      data))
  }

  public deleteRequest(apiEndpoint: string) {
    this.sharedDataService.toggleProgressBarOn()
    return this.http.delete(
      `${environment.url}/${environment.backendVersion}/${apiEndpoint}`
    ).pipe(map(data => data))
  }

  public patchRequest(apiEndpoint: string, payload?: any, header?: HttpHeaders) {
    this.sharedDataService.toggleProgressBarOn()
    return this.http.patch<any>(
      `${environment.url}/${environment.backendVersion}/${apiEndpoint}`,
      payload,
      {
        headers: header ? header : {}
      }
    ).pipe(map(data => data))
  }
}
